export const getRouteWithoutParams = (route) => route.split(':')[0];
